export class instaQuoteApi {

    private props: any;

    private handleInstaQuote: any;

    private moveToNextStep: boolean;

    constructor(local: any, moveToNextStep: boolean, handleInstaQuote: (this: void) => any) {
        this.props = local;
        this.moveToNextStep = moveToNextStep
        this.handleInstaQuote = handleInstaQuote;
    }

    async GetInstaquoteData() {
        const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' },
            body: new URLSearchParams({
                "MovingFromInput": this.props.values.movingFromAddrComponent.MovingFromInput,
                "MovingFromAddress": this.props.values.movingFromAddrComponent.MovingFromAddress,
                "MovingFromCity": this.props.values.movingFromAddrComponent.MovingFromCity,
                "MovingFromState": this.props.values.movingFromAddrComponent.MovingFromState,
                "MovingFromZip": this.props.values.movingFromAddrComponent.MovingFromZip,
                "MovingFromCountryCode": this.props.values.movingFromAddrComponent.MovingFromCountryCode,
                "MovingFromClientValidated": "true",
                "MovingToInput": this.props.values.movingToAddrComponent.MovingToInput,
                "MovingToAddress": this.props.values.movingToAddrComponent.MovingToAddress,
                "MovingToCity": this.props.values.movingToAddrComponent.MovingToCity,
                "MovingToState": this.props.values.movingToAddrComponent.MovingToState,
                "MovingToZip": this.props.values.movingToAddrComponent.MovingToZip,
                "MovingToCountryCode": this.props.values.movingToAddrComponent.MovingToCountryCode,
                "MovingToClientValidated": "true",
                "MoveDate": this.props.values.movingDateString,
                "home-type": "house",
                "home-size": this.getHomeSizeforAPI(),
                "DwellingType": this.getHomeSizeforAPI(),
                "Name": this.props.values.contactName,
                "Email": this.props.values.contactEmail,
                "Phone": this.props.values.contactPhone,
                "WidgetSpecificRefCode": "",
                "DeviceType": "Desktop",
                "quote-range": "Medium"
            })
        };

        console.log("Starting instaquote the API Call");

        let apiSuccess = false;
        //Call Instaquote API
        await fetch('/json/default-quote/get-quote', requestOptions)
            .then(response => response.json())
            .then((data) => {
                console.log("Got Data instaquote the API Call");
                this.handleInstaQuote(data, this.moveToNextStep);
                apiSuccess = true;
            },
                (error) => {
                    console.error(error);
                    this.handleInstaQuote(error, this.moveToNextStep);
                    apiSuccess = false;
                });

        return apiSuccess;
        
    }

    getHomeSizeforAPI() {
        switch (this.props.values.houseSize) {
            case "small":
                return "H1";

            case "medium":
                return "H2";

            case "large":
                return "H4";

            default:
                return "H2"
        }
    }
}